/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.tig-check[_ngcontent-%COMP%]{width:23px;height:23px;display:inline-block;vertical-align:middle;background:url(green.aded8c8c9fd7ad9e5a6a.png) no-repeat;cursor:pointer;padding:0;position:relative}div.tig-check[_ngcontent-%COMP%]:not(.checked):not(.disabled):hover{background-position:-24px 0}div.disabled[_ngcontent-%COMP%]{cursor:not-allowed}div.checked[_ngcontent-%COMP%]{background-position:-48px 0}div.tig-check[_ngcontent-%COMP%]    input{width:23px;height:23px;position:absolute;opacity:0;left:0;top:0;margin:0}"];
export { styles as styles };
